import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createURL } from '@sm/utils';

import './pricing-navigation.scss';

export const ROUTE_CONFIG = {
  teamsPricingPage: {
    path: '/pricing/',
    title: 'Business Plans',
    queryString: {
      ut_source: 'pricing-summary',
    },
    packageType: 'teams',
  },
  individualPricingPage: {
    path: '/pricing/individual/',
    title: 'Personal Plans',
    queryString: {
      ut_source: 'pricing-summary',
    },
    packageType: 'individual',
  },
  audienceFooter: {
    path: '#buy-targeted-responses',
    title: 'Buy Targeted Responses',
    packageType: 'enterprise',
  },
};
const ROUTE_KEYS = Object.keys(ROUTE_CONFIG);

const NavItem = ({ route, selected = false }) => {
  const className = classnames('wds-tab__tab', {
    'wds-tab__tab--selected': selected,
  });
  const url = createURL(route.path, route.queryString);
  const { title } = route;

  return (
    <li className={className}>
      <a href={url} className="wds-tab__tab-btn wds-p-b-2" role="tab" aria-selected={selected} tabIndex="0">
        <span className="sm-pricing-navigation__item wds-p-l-2 wds-p-r-2">{title}</span>
      </a>
    </li>
  );
};

NavItem.propTypes = {
  route: PropTypes.shape({
    path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    queryString: PropTypes.shape(),
    packageType: PropTypes.string.isRequired,
  }),
  selected: PropTypes.bool,
};

NavItem.defaultProps = {
  route: {
    queryString: null,
  },
  selected: false,
};

const PricingNavigation = ({ packageType = 'teams' }) => (
  <nav className="wds-tab wds-tab--light wds-tab--center wds-m-b-6 sm-pricing-navigation">
    <ul role="tablist" className="wds-tab__tabs">
      {ROUTE_KEYS.map(routeName => {
        const route = ROUTE_CONFIG[routeName];
        return <NavItem route={route} selected={packageType === route.packageType} key={routeName} />;
      })}
    </ul>
  </nav>
);

PricingNavigation.propTypes = {
  packageType: PropTypes.string,
};

PricingNavigation.defaultProps = {
  packageType: 'teams',
};

export default PricingNavigation;
